export default () => ({
  component: 'grade-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
